import { useCallback } from 'react'
import { useStoreSessionToken } from '@retailer-platform/dashboard/apollo'
import { useEnterpriseAccountAccountSetupMutation } from '../../../api'

interface AccountSetup {
  rawToken: string
  password: string
  givenName: string
  surname: string
  reCaptchaToken?: string
  turnstileToken?: string
}

/**
 * @deprecated Set up should not be triggered here. Please talk with #ipp-away-teams if you need to trigger set up.
 */
export const useEnterpriseAccountAccountSetup = () => {
  const [triggerMutation, { data, loading, error }] = useEnterpriseAccountAccountSetupMutation()

  const triggerAccountSetup = useCallback(
    (args: AccountSetup) =>
      triggerMutation({
        variables: {
          ...args,
        },
      }),
    [triggerMutation]
  )

  const apiSuccess = Boolean(data)
  const token = data?.enterpriseAccountAccountSetup?.accessToken.token
  const { completed } = useStoreSessionToken(token)

  return {
    triggerAccountSetup,
    apiSuccess: apiSuccess && completed,
    apiLoading: loading || (apiSuccess && !completed),
    apiError: error,
  }
}
